export default __webpack_public_path__ + "static/media/pic1.767c7c71.jpg";